module.exports = __webpack_public_path__ + "static/treninky-1.85d20e4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/treninky-1.jpg
// module id = 470
// module chunks = 126072307104019